// extracted by mini-css-extract-plugin
module.exports = {"menuButtonArrow":"MenuButton_menuButtonArrow__3Nvtk","menuItemTextDanger":"MenuButton_menuItemTextDanger__2qfci"};